import React, { useEffect, useMemo } from "react";
import { message, Spin } from "antd";
import {
    Redirect,
    Route,
    RouteComponentProps,
    Switch,
    useHistory
} from "react-router-dom";
import ProjectionLayout from "./components/ProjectionLayout";
import ProjectionLayoutBase from "./components/ProjectionLayout/LayoutBase";
import { getCourseData, toNumber } from "service/service";
import useRequest from "utils/useRequest";
import _ from "underscore";
import Resource from "./Resource";
import SignIn from "./SignIn";
import RollCall from "./RollCall";
import Vote from "./Vote";
import Exercise from "./Exercise";
import Homework from "./Homework";
import CacheRoute, { CacheSwitch } from "react-router-cache-route";
import style from "./index.module.scss";
import { CourseContext } from "./Store";
import { LayoutRoute } from "../../components/LayoutRoute";
import { Provider } from "jotai";
import GroupRoot from "./Group";

interface CourseProjectionProps {
    weekTimeId: string;
}

export default function CourseProjection({
    match
}: RouteComponentProps<CourseProjectionProps>) {
    const history = useHistory();
    const weekTimeId = toNumber(match.params.weekTimeId);
    const [CourseData, { loading }] = useRequest(
        () => getCourseData({}),
        {},
        []
    );
    const course = useMemo(
        () => _.find(CourseData || [], { weekTimeId }),
        [weekTimeId, CourseData]
    );

    const basename = `/course/projection/${weekTimeId}`;
    const path = history.location.pathname
        .substr(basename.length + 1)
        .split("/")[0]; // 模块路径

    // 防止全屏模式不显示提示信息
    useEffect(() => {
        message.destroy();
        message.config({
            getContainer: () => document.querySelector(".PopupContainer") as any
        });

        return () => message.destroy();
    }, []);

    // 不考虑无课程的情况
    if (!course) return null;

    return (
        <Provider>
            <CourseContext.Provider value={{ course, basename, path }}>
                <Spin spinning={loading}>
                    <Switch>
                        <LayoutRoute
                            path={`${basename}/exercise/:exerciseId`}
                            component={Exercise}
                            layout={ProjectionLayoutBase}
                        />
                        <LayoutRoute
                            path={`${basename}/group/:activityId/:homeworkId?`}
                            component={GroupRoot}
                            layout={ProjectionLayoutBase}
                        />

                        <ProjectionLayout>
                            <CacheSwitch>
                                <CacheRoute
                                    className={style.page}
                                    path={`${basename}/resource`}
                                    exact
                                    component={Resource}
                                />
                                <Route
                                    path={`${basename}/sign`}
                                    exact
                                    component={SignIn}
                                />
                                <CacheRoute
                                    className={style.page}
                                    path={`${basename}/rollcall`}
                                    exact
                                    component={RollCall}
                                />
                                <Route
                                    path={`${basename}/vote/:voteId`}
                                    exact
                                    component={Vote}
                                />
                                <Route
                                    path={`${basename}/homework`}
                                    exact
                                    component={Homework}
                                />
                                <Redirect to={`${basename}/resource`} />
                            </CacheSwitch>
                        </ProjectionLayout>
                    </Switch>
                </Spin>
            </CourseContext.Provider>
        </Provider>
    );
}
